import GenericDB from './generic-db';

export default class ClinicSettingsDB extends GenericDB {
  constructor() {
    super('clinicSettings');
  }
}
